const base64 = globalThis as unknown as {
  atob?: (value: string) => string;
  btoa?: (value: string) => string;
  Buffer?: {
    from: (
      value: string,
      encoding: string,
    ) => {
      toString: (encoding: string) => string;
    };
  };
};

/** Encodes the `Type:id` Relay global-ID form used by the CRM APIs. */
export const encodeGlobalId = (type: string, id: string): string => {
  const value = `${type}:${id}`;
  if (base64.Buffer != null) {
    return base64.Buffer.from(value, 'utf8').toString('base64');
  }
  if (base64.btoa != null) {
    return base64.btoa(value);
  }
  throw new Error('No base64 encoder available');
};

/** Decodes the `Type:id` Relay global-ID form used by the CRM APIs. */
export const decodeGlobalId = (
  globalId: string,
): { type: string; id: string } | null => {
  try {
    // Preserve atob's invalid-base64 rejection before Buffer's permissive decode.
    const binaryValue = base64.atob?.(globalId);
    const value =
      base64.Buffer?.from(globalId, 'base64').toString('utf8') ?? binaryValue;
    if (value == null) {
      return null;
    }
    const separatorIndex = value.indexOf(':');
    if (separatorIndex === -1) {
      return null;
    }
    return {
      type: value.slice(0, separatorIndex),
      id: value.slice(separatorIndex + 1),
    };
  } catch {
    return null;
  }
};
